module.exports = __webpack_public_path__ + "img/maru.9b848efa.png";